// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col-message[data-v-7edbc2f8] {\n  max-width: 500px;\n}\n.col-message div[data-v-7edbc2f8] {\n  display: block;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.col-width div[data-v-7edbc2f8] {\n  width: 160px;\n}", ""]);
// Exports
module.exports = exports;
